import { encodeRegionNameURI } from 'pages/Map/regionHelper';

export const GEAR_ROUTE = '/gear';
export const APPOINTMENTS_ROUTE = '/appointments';
export const NEW_APPOINTMENTS_ROUTE = '/appointments/new';
export const SYMPTOMS_ROUTE = '/symptoms';
export const NEW_SYMPTOMS_ROUTE = '/symptoms/new';
export const MEDICATIONS_ROUTE = '/medications';
export const NEW_MEDICATIONS_ROUTE = '/medications/new';
export const VERIFICATION_ROUTE = '/verification';
export const SIGN_UP_ROUTE = '/sign-up';
export const LOGIN_ROUTE = '/login';
export const LANDING_ROUTE = '/';
export const HOME_ROUTE = '/home';
export const CAPTURE_PROFILE_ROUTE = '/capture-profile';
export const CAPTURE_MAP_ROUTE = '/capture-map';
export const REQUEST_RECOVER_CODE_ROUTE = '/request-recover-code';
export const RESET_PASSWORD_ROUTE = '/reset-password';
export const RECOVER_ACCOUNT_ROUTE = '/recover-account';
export const ORY_SETTINGS_ROUTE = '/settings';
export const ACCOUNT_SETTINGS_ROUTE = '/account/settings';
export const ACCOUNT_VERIFIED_ROUTE = '/account-verified';
export const MAP_INFO_ROUTE = '/map-info';
export const USER_MANAGEMENT_ROUTE = '/user-management';
export const MY_PROFILE = '/my-profile';

export const ERROR_ROUTE = '/error';
export const GUIDES_ROUTE = '/guides';
export const REQUEST_MAP_ROUTE = '/request-map';
export const MAP_ONBOARDING = '/map-onboarding';
export const ONBOARDING_LANDING = '/onboarding-landing';

export const MY_MAP_ROUTE = '/my-map';
export const MAP_ROUTE = `${MY_MAP_ROUTE}/:region/:zoneName`;
export const getMapRoute = (region: string, zoneName: string) => {
    return `${MY_MAP_ROUTE}/${encodeRegionNameURI(region)}/${zoneName}`;
};

export const USER_DETAILS = '/user-details';
export const getUserDetailRoute = (userID?: string) => {
    return `${USER_DETAILS}/${userID}`;
};

export const USER_MAP_ROUTE = ':region/:zoneName';
export const getUserMapRoute = (userID: string, region: string, zoneName: string) => {
    return `${USER_DETAILS}/${userID}/${encodeRegionNameURI(region)}/${zoneName}`;
};

export const ASSIGN_MAP_ROUTE = 'assign-map';
export const getAssignMapRoute = (userID?: string) => `${USER_DETAILS}/${userID}/assign-map`;

export const getGuideRoute = (id: string) => `${GUIDES_ROUTE}/${id}`;
